<template>
  <popup
    v-if="isManager('project|maintenance|finance|management|admin')"
    button-style="primary"
    heading="New Sharer"
    :show-text="showText"
    button-text="Sharer"
    size="medium"
    button-icon="fa fa-plus"
    :disable-button="!isManager('project|finance') || readOnly"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <div class="padded" style="clear: both; text-align: left;">

    <el-row justify="start" align="middle">
    <el-form ref='licenseeForm' v-model="telco" label-position="top">
      <el-row :gutter="8">

        <el-col :sm="24" :md="12">
          <select-sharer :size="size" v-model="telco.organisation_id" placeholder="Select Sharer" requried />
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
            <text-input label="Their Site ID"  :size="size" v-model='telco.telcoSiteId' />
        </el-col>

     </el-row>


       <el-row :gutter="8">

        <el-col :sm="24" :md="12">
          <select-service-type  :size="size" v-model="telco.serviceType" />
        </el-col>

        <el-col :sm="24" :md="12">
          <select-spectrum   :size="size" v-model="telco.spectrumBand" />
        </el-col>

      </el-row>

      <el-row :gutter="8">
        <el-col :sm="24">
          <sharer-rate-override
            v-model="telco.rate_id"
            :sharer-id="telco.organisation_id"
            :disabled="readOnly || !telco.organisation_id" />
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Handover Date'>
            <el-date-picker :format="format" :size="size"
            v-model="telco.handover" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Commencement Date'>
            <el-date-picker :format="format" :size="size"
            v-model="telco.started" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='On Air Date'>
            <el-date-picker :format="format" :size="size"
            v-model="telco.onAir" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Expiry Date'>
            <el-date-picker :format="format" :size="size"
            label='Contract End' v-model='expiryDate' disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :md="24" :lg="10">
          <el-form-item label='Tenor (years)'>
            <el-slider :size="size"
            v-model="tenor" :min="1" :max="20" show-stops show-input>
          </el-slider>
        </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6" :offset="2"> <!-- BUG: need to change to add equipment -->
          <number-input label="Cabins" :size="size" :min="0" :max="10" v-model="telco.cabin" />
        </el-col>

      <el-col :sm="24" :md="12" :lg="6"> <!-- BUG: need to change to add equipment -->
         <check-box :label="'Own ' + utilLabel + ' Meter'" v-model="telco.ownMeter" />
       </el-col>

      </el-row>

      <el-row v-if="canAccess('finance')" :gutter="8">
        <el-col :sm="24" :md="12" :lg="4">
          <float-input label="Sharer Specific CAPEX" placeholder="CAPEX" :size="size" v-model='telco.capex' />
        </el-col>

        <el-col :sm="24" :md="12" :lg="4">
          <float-input label="Sharer Specific OPEX" placeholder="OPEX" :size="size" v-model='telco.opex' />
        </el-col>
      </el-row>


    </el-form>
  </el-row>

</div>

  </popup>

</template>



<script>

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import SelectSharer from '@/components/atoms/selects/SelectSharer'
import SharerRateOverride from '@/components/finance/rates/SharerRateOverride'

export default {

  mixins: [DateMixins, PostMixins],

  components: {
    SelectSharer,
    SharerRateOverride
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    siteId: {
      type: [String, Number],
      default: null
    },

    tableRef: {
      type: String,
      default: 'telcotable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    // Pushes posts to the server when called.
    resetData () {
      this.telco = this.getTableStruct('licensees')
      this.telco.site_id = this.siteId ? this.siteId : this.rowData.site_id
    },

    onSaveDialog () {
      this.telco.site_id = this.siteId ? this.siteId : this.rowData.id

      if (this.telco.started === 'invalid date') {
        this.telco.started = null
      }

      if (this.telco.expiry === 'invalid date') {
        this.telco.expiry = null
      }

      this.telco.outdoor = !this.telco.cabin

      this.telco.started = this.formatDateSql(this.telco.started)
      this.telco.expiry = this.formatDateSql(this.telco.expiry)
      this.telco.handover = this.formatDateSql(this.telco.handover)
      this.telco.onAir = this.formatDateSql(this.telco.onAir)

      this.refreshStats(this.telco.site_id)

      this.saveForm(this, '/licensees', this.telco.id, this.telco, 'Sharer', this.success)
      this.$emit('update-stats')
    },

    onCloseDialog () {
      this.resetData()
      this.$emit('update-stats')
    },

    success () {

      if (this.telco.cabin > 0) {
        let cabinAsset = {}
        cabinAsset.owner_id = this.telco.organisation_id
        cabinAsset.site_id = this.telco.site_id
        cabinAsset.category = 'Buildings'
        cabinAsset.type = 'Cabin'
        cabinAsset.qty = this.telco.cabin
        cabinAsset.isAuditable = true
        cabinAsset.usesPower = true

        this.saveForm(this, '/assets', null, cabinAsset, 'Cabins', null, null, false)
      }


      if (this.telco.ownMeter) {
        let meterAsset = {}
        meterAsset.owner_id = this.telco.organisation_id
        meterAsset.site_id = this.telco.site_id
        meterAsset.category = 'Power'
        meterAsset.type = 'Own Meter'
        meterAsset.qty = 1
        meterAsset.isAuditable = false
        meterAsset.providesPower = true
        meterAsset.usesPower = false

        this.saveForm(this, '/assets', null, meterAsset, 'Own Meter', null, null, false)
      }

      this.$events.emit(this.tableRef + '-refresh-table')
      this.resetData()
    }
  },

  computed: {
    expiryDate: function () {
      this.telco.expiry = this.contractExpiryDate(this.telco.started, this.tenor, 'years', 'YYYY-MM-DD')
      return this.telco.expiry
    }
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(this.rowData),
      format: settings.selectDateFormat,
      size: this.isSmall ? 'medium' : 'large',
      tenor: 10,
      telco: this.getTableStruct('licensees')
    }
  } // data

}

</script>
